import React from 'react'
import './youtuVideoBanner.scss'

export default function YoutubeVideoBanner(props) {
  const videoId = props.videoId
  return (
    <div className="video-banner text-center">
      <div className='video-section'>
        <iframe
          className="video-container"
          src={`https://www.youtube.com/embed/${videoId}?origin=https://reverhealthsolution.com"`}
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  )
}
